module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAABZElEQVQ4ja2UOUsDURSFv7iACrFMK4gLiIrWAcXCQrC1EbfaQhALKxu1sRWsxeUHWIh2ohisDGglBMFaA2LQgInFWMwJ8xxnz1y4MPfdc885b+bNg+AYA16BD+DRo58HrKBsCxFYA3J6HgUmgRujXwbOgYzHrAV8B5FngQpQA0oauAgxFCsWRVoARnC23Z2WQFGEW6ofVG+mQd6L47hHaxuqS2kI7IvszljLGqL5ZgWqIlpwrV9q/bQZ8nmRVLBdmzGNs4uupAK3Ijj26GUkbAGrScj7cBwO+GD21H9OIrCr4SfVHUY2XsmwYWI8rsC7Bn+w758vI6vAunD3wh3GIZ+B/5eVK2vCLuN/EP6EeUldAVPANfbfarn6rcoC0ALUVa8AR2Huc4bL2TCw4kz4YhTwjsBvQHtEgQnDVH8Y+EXAg4jkjShHmZsznAzFFNg2Zjv9QCfAJ/bHjRuD2Ee7Dix5AX4BWs1zBUFPoAEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/down-size.png
// module id = 9mr1
// module chunks = 1